/**
 * @file Fichier de configuration globale de l'application.
 * @description Contient toutes les variables d'environnement et les limites techniques.
 * Ce fichier doit IMPÉRATIVEMENT être chargé en premier dans le HTML.
 */

/**
 * Objet global de configuration (Lecture seule recommandée).
 * @constant {Object} CONFIG
 * @property {boolean} DEBUG_MODE - Active ou désactive les `debugLog` dans la console. À passer sur `false` pour la mise en production.
 * @property {string} APP_VERSION - Numéro de version actuel de l'application (format Semantic Versioning).
 * @property {string} APP_NAME - Nom public de l'application, utilisé pour les titres ou l'interface.
 * @property {number} MAX_IMAGE_WIDTH - Largeur maximale (en pixels) imposée aux couvertures lors du redimensionnement et de la compression WebP.
 * @property {string} DB_NAME - Le nom de la base de données IndexedDB dans le navigateur.
 * @property {number} DB_VERSION - La version de la base. À incrémenter (2, 3...) uniquement si la structure des tables change.
 * @property {string} DB_STORE_NAME - Le nom de l'Object Store qui contient les bandes dessinées de la collection.
 * @property {string} DB_WISH_STORE_NAME - Le nom de l'Object Store qui contient la liste de souhaits d'achat.
 */
export const CONFIG = {

    // --- ENVIRONNEMENT ---
    DEBUG_MODE: true,

    // --- MÉTADONNÉES ---
    // APP_VERSION est injecté dans le HTML au build via scripts/build-html.js (source : package.json)
    APP_NAME: "Mes BD",

    // --- LIMITES TECHNIQUES ---
    MAX_IMAGE_WIDTH: 243,

    // --- BASE DE DONNÉES (IndexedDB) ---
    DB_NAME: "ComicsDatabase",
    DB_VERSION: 2,
    DB_STORE_NAME: "comics",
    DB_WISH_STORE_NAME: "wishlist"
};

// Verrouiller l'objet pour empêcher sa modification accidentelle par un autre script
Object.freeze(CONFIG);
